<template>
    <div class="flexbox font-s13 dati-k">
        <!-- 序号&题目 -->
        <div class="flexbox-nav">
            <div class="tit-pc">开始答题</div>
            <div class="answer-t flex-szb">
                <div class="answer-sz">
                    <div class="a-con">
                        <img :src="getImgUrl('images/ui/dt-3.png')" alt="">
                        <div class="font-s15 fonts-sz1">{{timeLength}}</div>
                    </div>
                </div>
                <div class="a-tx fonts-sz1">
                    <div class="col-1 font-b">{{question.history_count+1}}</div>
                    <div>/</div>
                    <div>{{question.total}}</div>
                </div>
            </div>
        </div>
        <!--选项-->
        <div class="flexbox-content">
            <div class="answer-k">
                <div class="answer-s" v-if="question.type==1">单选题</div>
                <div class="answer-s" v-if="question.type==2">多选题</div>
                <div class="answer-s" v-if="question.type==3">判断题</div>
                <div class="answer">{{question.title}}</div>
            </div>
            <div class="answer-z">
                <label class="xuanze" v-for="op in question.options" v-if="question.type==1">
                    <input type="radio" v-model="danxAns" :value="Object.keys(op)[0]">
                    <div :style="op.height?{'height': op.height}:{}">
                        <div class="tm-num"><span>{{Object.keys(op)[0]}}</span></div>
                        <div class="tm-con">{{op[Object.keys(op)[0]]}}</div>
                    </div>
                </label>
                <label class="xuanze" v-for="op in question.options" v-if="question.type==2">
                    <input type="checkbox" v-model="duoxAns" :value="Object.keys(op)[0]">
                    <div :style="op.height?{'height': op.height}:{}">
                        <div class="tm-num"><span>{{Object.keys(op)[0]}}</span></div>
                        <div class="tm-con">{{op[Object.keys(op)[0]]}}</div>
                    </div>
                </label>
                <label class="xuanze" v-if="question.type==3">
                    <input type="radio" v-model="pdAns" value="true">
                    <div style="height: 1.2rem">
                        <div class="tm-num"><span>A</span></div>
                        <div class="tm-con">正确</div>
                    </div>
                </label>
                <label class="xuanze" v-if="question.type==3">
                    <input type="radio" v-model="pdAns" value="false">
                    <div style="height: 1.2rem">
                        <div class="tm-num"><span>B</span></div>
                        <div class="tm-con">错误</div>
                    </div>
                </label>
            </div>
        </div>
        <!--End-->
        <div class="flexbox-footer">
            <a class="start-dt col-j1" @click="submitNext()">提交进入下一题</a>
        </div>
        <tips :show="show" :content="content" @hide-tips="closeTips"></tips>
    </div>
</template>

<script>
    export default {
        name: "Question",
        data: function () {
            return {
                show: false,
                content: '',
                examId: null,
                merUid: null,
                examResId: null,
                question: {},
                danxAns: "",
                duoxAns: [],
                pdAns: null,
                form: {
                    mer_user_id: null,
                    exam_id: null,
                    exam_result_id: null,
                    question_id: null,
                    answer: "",//["A","B","C"] ,["A"],["true"]
                },
                tipsAfter:false,
                nextQuestionFlag:false,
                timeInterval:null,
                timeLength:"",
                isMobile:false,
            }
        },
        mounted: function () {
            this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Symbian/i.test(navigator.userAgent);
            document.title = "考试";
            document.body.className = "col-b1 flex-sh login-pc";
            window.setCss("/css/dati.css");

            this.examId = this.$route.query.examId;
            this.merUid = this.$route.query.merUid;
            this.examResId = this.$route.query.examResId;

            this.form.mer_user_id = this.merUid;
            this.form.exam_id = this.examId;
            this.form.exam_result_id = this.examResId;

            this.nextQuestion();
        },
        methods: {
            closeTips(type) {
                this.show = false;
                if(type=="ok" ){
                    if(this.tipsAfter){
                        this.tipsAfter=false;
                        this.$router.push({path:'/home/result?merUid='+this.merUid+"&examId="+this.examId+"&examResId="+this.examResId});
                        return;
                    }
                }

                if(this.nextQuestionFlag){
                    this.nextQuestionFlag=false;
                    this.nextQuestion();
                    return;
                }
            },
            getImgUrl(path) {
                return process.env.BASE_URL + path;
            },
            nextQuestion() {
                let _that_ =this;
                this.$axios.get("/exam/next/question?examId=" + this.examId + "&merUid=" + this.merUid + "&examResId=" + this.examResId).then(res => {
                    if(res.data.code != this.$webConfig.httpSuccessStatus){
                        this.content =res.data.message;
                        this.show = true;
                        this.nextQuestionFlag=true;
                        return;
                    }
                    if(res.data.data && res.data.data.is_over == 1){
                        this.content ="答题结束，查看成绩";
                        this.show = true;
                        this.tipsAfter=true;
                        return;
                    }
                    this.question = res.data.data;
                    if(res.data.data.content && res.data.data.content!=""){
                        this.question.options = JSON.parse(res.data.data.content);
                        if(this.question.type!=3) {
                            this.question.options.forEach(item => {
                                if (this.isMobile) {
                                    let _length = item[Object.keys(item)].length;
                                    if (_length >= 40 && _length < 70) {
                                        item.height = '2rem';
                                    } else if (item[Object.keys(item)].length >= 70) {
                                        item.height = '3rem';
                                    } else {
                                        item.height = '1.2rem';
                                    }
                                }
                            })
                        }
                    }
                    this.form.question_id = this.question.id;
                    if(this.timeInterval!=null){
                        window.clearInterval(this.timeInterval);
                    }
                    this.timeInterval = window.setInterval(function(){
                        _that_.question.has_time = _that_.question.has_time -1;
                        if(_that_.question.has_time<=1){
                            _that_.endExam();
                        }
                        _that_.timeLength = _that_.secondToTimeStr(_that_.question.has_time);
                    },1000);
                })
            },
            secondToTimeStr(t) {
                if (!t) return;
                if (t < 60) return "00:" + ((i = t) < 10 ? "0" + i : i);
                if (t < 3600) return "" + ((a = parseInt(t / 60)) < 10 ? "0" + a : a) + ":" + ((i = t % 60) < 10 ? "0" + i : i);
                if (3600 <= t) {
                    var a, i, e = parseInt(t / 3600);
                    return (e < 10 ? "0" + e : e) + ":" + ((a = parseInt(t % 3600 / 60)) < 10 ? "0" + a : a) + ":" + ((i = t % 60) < 10 ? "0" + i : i);
                }
            },
            submitNext() {
                if (this.question.type == 1) {
                    if (this.danxAns == null || this.danxAns == '') {
                        this.content = "请选择答案";
                        this.show = true;
                        return;
                    }
                    this.form.answer = JSON.stringify([this.danxAns]);
                }
                if (this.question.type == 2) {
                    if (this.duoxAns == null || this.duoxAns.length <= 0) {
                        this.content = "请选择答案";
                        this.show = true;
                        return;
                    }
                    this.form.answer = JSON.stringify(this.duoxAns);
                }
                if (this.question.type == 3) {
                    if (this.pdAns == null || this.pdAns == '') {
                        this.content = "请选择答案";
                        this.show = true;
                        return;
                    }
                    this.form.answer = JSON.stringify([this.pdAns]);
                }
                this.$axios.post("/answers/submit", this.form).then(res => {
                    if(res.data.code!=this.$webConfig.httpSuccessStatus){
                        this.content = res.data.message;
                        this.show = true;
                        if(res.data.code=="3000002" || res.data.code=="3000003"){
                            this.tipsAfter=true;
                        }
                    }else{
                        //清空本题的选择项，并读取下一题
                        this.danxAns='';
                        this.duoxAns=[];
                        this.pdAns=null;
                        this.form.answer="";
                        this.nextQuestion();
                    }
                });

            },
            endExam(){
                if(this.timeInterval!=null){
                    window.clearInterval(this.timeInterval);
                }
                this.$axios.get("/answers/end?examId=" + this.examId + "&merUid=" + this.merUid + "&examResId=" + this.examResId).then(res=>{
                    //啥也不做，用户点击按钮，服务端会出发考试结束的提示
                })
            }
        }
    }
</script>

<style scoped>

</style>
